<template>
  <div id="app">
    <pcHeader></pcHeader>
    <router-view />
    <client-service></client-service>
    <footGuide class="page-footer-module"></footGuide>
  </div>
</template>
<script>
export default {
  name: 'app',
  data() {
    return {}
  },
  created() { },
  watch: {},
  methods: {},
  mounted() {
    // var zhiManager = getzhiSDKInstance()
    // zhiManager.set('manTrance', 'true')
    // zhiManager.set('customBtn', 'true')
    // zhiManager.on('load', function (ret) {
    //   zhiManager.initBtnDOM()
    // })
  },
  components: {}
}
</script>
<style lang="less">
#app {
  // 防止详情页出现页面抖动
  min-height: 100vh;
  position: relative;
}
</style>


